module.exports = __webpack_public_path__ + "static/media/TBTC-BTCB.87f87cd6.svg";